import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { EddEmbeddedFields } from '../../embedded/fields.types';
import { useBusinessCapitalLogic } from './hooks/useBusinessCapitalLogic';
import { BusinessCapitalForm } from './BusinessCapitalForm';

export const EddBusinessCapital = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading, optionsList } = useBusinessCapitalLogic();

  const reactiveOptions = formMethods.watch(EddEmbeddedFields.EDD_BUSINESS_CAPITAL_SOURCE);

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('organic.businessCapital.title')}
        text={t('organic.businessCapital.subtitle')}
        textCustomStyle='mt-[24px] text-text-main-primary text-[16px]'
        headingContainerCustomStyle='!mb-[16px]'>
        <BusinessCapitalForm reactiveOptions={reactiveOptions} optionsList={optionsList} />
      </StepPageWrapper>
    </FormProvider>
  );
};
